import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import AddOnsService from "../../../../services/AddOnsService";
import { Translate } from "../../../Enums/Tranlate";
import DeleteModal from "../../../common/DeleteModal";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const addOnsService = new AddOnsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item[`name_${lang}`]}</td>
			<td className="text-wrap-mode">{item?.vender[`name_${lang}`]}</td>
			<td className="text-wrap-mode">{item?.quantity}</td>
			<td className="text-wrap-mode">
				{item?.price?.toFixed(3)} {Translate[lang].kwd}
			</td>
			<td className="text-wrap-mode">
				{!!item?.image ? (
					<a
						href={item?.image}
						className="cursor-pointer"
						target="_blank"
						rel="noreferrer">
						<img
							src={item?.image}
							alt="ons"
							width={40}
							height={40}
							style={{ borderRadius: "6px" }}
						/>
					</a>
				) : (
					"-"
				)}
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{isExist("update_add_ons") && (
						<img
							src={editIcon}
							onClick={() => {
								navigate("/add-add-ons", { state: item });
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{isExist("delete_add_ons") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item?.name_en : item?.name_ar}
					deletedItem={item}
					modelService={addOnsService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
